/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @TODO remove "Vue.extend" from module export
 */
const __vue_script__ = Vue.extend({

  /** @since 3.8.6 */
  name: 'form-footer',

  props: {
    state: {
      type: Object
    },
    backToRoot: {
      type: Function,
      default: () => {}
    },
    isRootComponent: {
      type: Function
    }
  },
  data() {
    /**
     * need toget a deep copy of buttons
     * @type {T[]}
     */
    this.originalbuttons = this.state.buttons.map(button => ({
      ...button
    }));
    return {
      id:     "footer",
      active: true,
      show:   true,
    }
  },
  computed: {
    enableSave() {
      return this.state.valid && this.state.update;
    }
  },
  methods: {
    exec(cbk) {
      cbk instanceof Function ? cbk(this.state.fields): (function() { return this.state.fields})();
    },
    btnEnabled(button) {
      const { enabled = true, type } = button;
      return enabled && (type !== 'save' ||  (type === 'save' && this.enableSave));
    },
    isValid() {
      return this.state.valid;
    },
  },
  watch: {
    'state.component'(component) {
      this.show = this.isRootComponent(component)
    },
    'state.update': {
      immediate: true,
      handler(value) {
        this.state.buttons.find((button, index) => {
          if (button.eventButtons && button.eventButtons.update) {
            if (button.eventButtons.update[value]) {
              this.state.buttons.splice(index,1, {
                ...button,
                ...button.eventButtons.update[value]
              })
            } else {
               this.state.buttons.splice(index,1, this.originalbuttons[index]);
            }
          }
        });
      }
    }
  },
  activated() {
    this.active = true;
  },
  deactivated() {
    this.active = false;
  }
});


/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group g3wform_footer"},[(_vm.show)?[_vm._t("default",function(){return [_c('div',{staticStyle:{"margin":"3px","font-weight":"bold"}},[_vm._v("\n        * "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.form.footer.required_fields'),expression:"'sdk.form.footer.required_fields'"}]}),_vm._v(" "),(_vm.state.footer.message)?_c('div',{style:([_vm.state.footer.style])},[_vm._v("\n          "+_vm._s(_vm.state.footer.message)+"\n        ")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.state.buttons),function(button){return _c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.btnEnabled(button)),expression:"!btnEnabled(button)"},{name:"t",rawName:"v-t",value:(button.title),expression:"button.title"}],key:button.id,staticClass:"btn",class:[button.class],attrs:{"update":_vm.state.update,"valid":_vm.state.valid},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.exec(button.cbk)}}})})]})]:[_c('button',{directives:[{name:"t",rawName:"v-t",value:('back'),expression:"'back'"}],staticClass:"btn skin-button",on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"prevet",undefined,$event.key,undefined)){ return null; }$event.stopPropagation();return _vm.backToRoot.apply(null, arguments)}}})]],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "FormFooter.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__